export default "__VITE_ASSET__CTl9oeKZ__"